import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Get in Touch',
  description: 'Call us or fill out our online form to discuss your heating needs.'
}, {
  number: '02',
  title: 'Free Quote',
  description: 'We provide a transparent, no-obligation quote with upfront pricing.'
}, {
  number: '03',
  title: 'Expert Installation',
  description: 'Our Gas Safe engineers complete the work safely and efficiently.'
}, {
  number: '04',
  title: 'Aftercare Support',
  description: 'We ensure everything runs perfectly and offer ongoing maintenance.'
}];
export function Process() {
  return <section className="py-24 relative z-10 bg-[#0a0a0a]" data-id="element-198">
      <div className="max-w-7xl mx-auto px-6" data-id="element-199">
        <div className="text-center mb-16" data-id="element-200">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-white" data-id="element-201">
            Simple, Stress-Free Process
          </motion.h2>
        </div>

        <div className="relative" data-id="element-202">
          {/* Connecting Line (Desktop) */}
          <motion.div initial={{
          scaleX: 0,
          opacity: 0
        }} whileInView={{
          scaleX: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-[#FF9500]/50 to-transparent origin-left" data-id="element-203"></motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-204">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-205">
                <div className="w-24 h-24 rounded-full bg-[#0a0a0a] border-2 border-white/10 flex items-center justify-center mb-6 relative z-10 group-hover:border-[#FF9500] transition-colors duration-300" data-id="element-206">
                  <span className="text-3xl font-black text-transparent bg-clip-text bg-gradient-primary" data-id="element-207">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-208">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-209">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}